var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpuPlugEm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100mm",
    height: "100mm",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.0124 2.1964)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.85734 0 0 .85734 12.215 13.404)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(.17 23.627 23.557)",
    x: 7.04,
    y: 7.04,
    width: 33.91,
    height: 33.91,
    rx: 2,
    ry: 2,
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(.17 23.627 23.557)",
    x: 16.02,
    y: 16.02,
    width: 15.96,
    height: 15.96,
    rx: 1,
    ry: 1,
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    x2: 24,
    y1: 47.77,
    y2: 41.77,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    x2: 29,
    y1: 47.77,
    y2: 41.77,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    x2: 34,
    y1: 47.77,
    y2: 41.77,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39,
    x2: 39,
    y1: 47.77,
    y2: 41.77,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    x2: 9,
    y1: 47.77,
    y2: 41.77,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    x2: 14,
    y1: 47.77,
    y2: 41.77,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    x2: 19,
    y1: 47.77,
    y2: 41.77,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    x2: 24,
    y1: 7,
    y2: 1,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    x2: 29,
    y1: 7,
    y2: 1,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    x2: 34,
    y1: 7,
    y2: 1,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39,
    x2: 39,
    y1: 7,
    y2: 1,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    x2: 9,
    y1: 7,
    y2: 1,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    x2: 14,
    y1: 7,
    y2: 1,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    x2: 19,
    y1: 7,
    y2: 1,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    x2: 1,
    y1: 24,
    y2: 24,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    x2: 1,
    y1: 19,
    y2: 19,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    x2: 1,
    y1: 14,
    y2: 14,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    x2: 1,
    y1: 9,
    y2: 9,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    x2: 1,
    y1: 39,
    y2: 39,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    x2: 1,
    y1: 34,
    y2: 34,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    x2: 1,
    y1: 29,
    y2: 29,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    x2: 41,
    y1: 24,
    y2: 24,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    x2: 41,
    y1: 19,
    y2: 19,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    x2: 41,
    y1: 14,
    y2: 14,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    x2: 41,
    y1: 9,
    y2: 9,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    x2: 41,
    y1: 39,
    y2: 39,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    x2: 41,
    y1: 34,
    y2: 34,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    x2: 41,
    y1: 29,
    y2: 29,
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.517 .517 -.517 -.517 99.621 63.847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1 36.091h7.297v6.464c0 1.654 1.346 3 3 3h10.25c0.145 0 0.28-0.033 0.404-0.089h2.846c0.552 0 1-0.448 1-1v-4.464h7.297c0.552 0 1-0.448 1-1v-4c0-0.553-0.448-1-1-1h-7.297v-1.911h7.297c0.552 0 1-0.448 1-1v-4c0-0.552-0.448-1-1-1h-7.297v-4.551c0-0.552-0.448-1-1-1h-3.25c-0.145 0-0.28 0.034-0.404 0.089h-9.846c-1.654 0-3 1.346-3 3v6.463h-7.297c-0.552 0-1 0.448-1 1v4c0 0.553 0.448 0.999 1 0.999zm31.095-0.088v2h-6.297v-2zm0-7.912v2h-6.297v-2zm-8.297-1v16.375h-1.25v-20.926h1.25zm-13.5-3.463c0-0.551 0.449-1 1-1h9.25v20.927h-9.25c-0.551 0-1-0.449-1-1v-11.464zm-8.298 8.463h6.297v2h-6.297z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.095 30.003h-7.297v-6.375c0-1.654-1.347-3-3-3h-9.845c-0.125-0.055-0.26-0.089-0.404-0.089h-3.25c-0.553 0-1 0.448-1 1v22.927c0 0.552 0.447 1 1 1h2.845c0.124 0.056 0.261 0.089 0.404 0.089h10.25c1.653 0 3-1.346 3-3v-6.553h7.297c0.552 0 1-0.448 1-1v-4c0-0.552-0.449-0.999-1-0.999zm-22.796-7.463h1.249v20.927h-1.249zm13.499 20.015c0 0.551-0.449 1-1 1h-9.249v-20.927h9.249c0.551 0 1 0.449 1 1v11.375zm8.297-8.552h-6.297v-2h6.297z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.798 23.835c-0.552 0-1 0.448-1 1v12.168c0 0.552 0.448 1 1 1s1-0.448 1-1v-12.168c0-0.553-0.448-1-1-1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpuPlugEm);
export default __webpack_public_path__ + "static/media/cpu-plug-em.9735fa922eb9c6d3d6bcc7b913c5dbe2.svg";
export { ForwardRef as ReactComponent };